import { render } from "./MovementES.vue?vue&type=template&id=b1455536&scoped=true"
import script from "./MovementES.vue?vue&type=script&lang=js"
export * from "./MovementES.vue?vue&type=script&lang=js"

import "./MovementES.vue?vue&type=style&index=0&id=b1455536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1455536"]])

export default __exports__